import { render, staticRenderFns } from "./commerceProductList.vue?vue&type=template&id=5f7f6fb7&"
import script from "./commerceProductList.vue?vue&type=script&lang=js&"
export * from "./commerceProductList.vue?vue&type=script&lang=js&"
import style0 from "./commerceProductList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports